import { isEmpty, isNumber, values } from "lodash";
import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Modal } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "wc-toast";
import { apiGet, apiPost } from "../utils/apiFetch";
import pathObj from "../utils/apiPath";
import obj from "../utils/constants";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
const SetLimit = ({ onClose, object }) => {
  const loaction = useLocation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm();
  const [status, setStatus] = useState(true);
  const [data, setData] = useState(obj.settingArrayNew);
  const handelChange = (object) => {
    if (object?.length > 0) {
      let betfair = object?.find((res) => {
        return res?.type == "betFaire";
      });
      let bookmaker = object?.find((res) => {
        return res?.type == "bookmaker";
      });
      let fancy = object?.find((res) => {
        return res?.type == "fancy";
      });
      let sportBook = object?.find((res) => {
        return res?.type == "sportBook";
      });
      if (!isEmpty(betfair)) {
        setValue("betFaireMin", betfair?.minAmount);
        setValue("betFaireMax", betfair?.maxAmount);
        setValue("betFaireBetDelay", betfair?.betDelay);
        setValue("betFaireExposure", betfair?.exposure);
      }
      if (!isEmpty(bookmaker)) {
        setValue("bookmakerMin", bookmaker?.minAmount);
        setValue("bookmakerMax", bookmaker?.maxAmount);
        setValue("bookmakerBetDelay", bookmaker?.betDelay);
        setValue("bookmakerExposure", bookmaker?.exposure);
      }
      if (!isEmpty(fancy)) {
        setValue("fancyMin", fancy?.minAmount);
        setValue("fancyMax", fancy?.maxAmount);
        setValue("fancyBetDelay", fancy?.betDelay);
        setValue("fancyExposure", fancy?.exposure);
      }
      if (!isEmpty(sportBook)) {
        setValue("sportBookMin", sportBook?.minAmount);
        setValue("sportBookMax", sportBook?.maxAmount);
        setValue("sportBookBetDelay", sportBook?.betDelay);
        setValue("sportBookExposure", sportBook?.exposure);
      }
    }
  };

  const onSubmit = async (body) => {
    let obj = [
      {
        type: "betFaire",
        minAmount: body?.betFaireMin,
        maxAmount: body?.betFaireMax,
        betDelay: body?.betFaireBetDelay,
        exposure: body?.betFaireExposure,
      },
      {
        type: "bookmaker",
        minAmount: body?.bookmakerMin,
        maxAmount: body?.bookmakerMax,
        betDelay: body?.bookmakerBetDelay,
        exposure: body?.bookmakerExposure,
      },
      {
        type: "fancy",
        minAmount: body?.fancyMin,
        maxAmount: body?.fancyMax,
        betDelay: body?.fancyBetDelay,
        exposure: body?.fancyExposure,
      },
      {
        type: "sportBook",
        minAmount: body?.sportBookMin,
        maxAmount: body?.sportBookMax,
        betDelay: body?.sportBookBetDelay,
        exposure: body?.sportBookExposure,
      },
    ];
    let objNew = {};
    if (object?.type == "series") {
      objNew = {
        seriesId: object?.id,
        data: obj,
        match: status ? "on" : "off",
      };
    } else {
      objNew = { eventId: object?.id, data: obj, match: status ? "on" : "off" };
    }

    try {
      let response = await apiPost(pathObj.updateSettingLimit, objNew);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        onClose();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getData = async () => {
    const { status, data: response_users } = await apiGet(pathObj.updateLimit, {
      eventId: object?.id,
    });
    if (status === 200) {
      if (response_users.success) {
        if (response_users?.results?.matchSetting?.length > 0) {
          setStatus(response_users?.results?.match == "on" ? true : false);
          handelChange(response_users?.results?.matchSetting);
        }
      }
    }
  };

  useEffect(() => {
    getData();
  }, [object]);

  console.log(status, "stat");
  return (
    <Modal size="2xl" show={true} onHide={onClose}>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="modal-title-status">
          {" "}
          Update Bet Config - {object?.matchname}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="">
          <div>
            <div className="d-flex align-items-center">
              <span style={{ fontWeight: "600" }}>Match Status On / Off</span>{" "}
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={status}
                onClick={(e) => {
                  setStatus(e?.target.checked);
                }}
              />
            </div>
          </div>
          <Container fluid>
            <Form onSubmit={handleSubmit(onSubmit)}>
              {data &&
                data?.map((item, index) => {
                  return (
                    <div className="d-flex">
                      <h2
                        style={{
                          width: "20%",
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                        className="common-heading "
                      >
                        {obj.settingHeading[item.type]}
                      </h2>

                      <Row>
                        <Col xl={3} lg={3} sm={6}>
                          <Form.Group className="d-flex align-items-start mb-2 flex-column">
                            {index == 0 && (
                              <Form.Label
                                style={{ fontSize: "16px" }}
                                className="pe-2 mb-2 w-lg-auto"
                              >
                                Min Bet
                              </Form.Label>
                            )}
                            <Form.Control
                              type="number"
                              name="minAmount"
                              placeholder="Min Bet"
                              style={{ width: "100%" }}
                              {...register(`${item?.type}Min`, {
                                required: {
                                  values: false,
                                },
                                validate: (value) => {
                                  if (value == 0 && !isEmpty(value)) {
                                    return "min should be greater than zero";
                                  }
                                },
                              })}
                              // onChange={(e) => {
                              //   if (
                              //     Number(e.target.value) > Number(item.maxAmount)
                              //   ) {
                              //     handelChange(e, item.type, true);
                              //   } else {
                              //     handelChange(e, item.type, false);
                              //   }
                              // }}
                            />
                          </Form.Group>
                        </Col>
                        <Col xl={3} lg={3} sm={6}>
                          <Form.Group className="d-flex align-items-start mb-2 flex-column">
                            {index == 0 && (
                              <Form.Label
                                style={{ fontSize: "16px" }}
                                className="pe-2 mb-2 w-lg-auto"
                              >
                                Max Bet
                              </Form.Label>
                            )}
                            <Form.Control
                              type="number"
                              name="maxAmount"
                              placeholder="Max Bet"
                              {...register(`${item?.type}Max`, {
                                required: {
                                  values: false,
                                },
                                validate: (value) => {
                                  if (
                                    Number(watch(`${item?.type}Min`)) >
                                    Number(value)
                                  ) {
                                    return "max should be greater than min";
                                  }
                                },
                              })}
                              // value={item.maxAmount}
                              // onChange={(e) => {
                              //   if (
                              //     Number(e.target.value) <= Number(item.minAmount)
                              //   ) {
                              //     handelChange(e, item.type, true);
                              //   } else {
                              //     handelChange(e, item.type, false);
                              //   }
                              // }}
                            />
                          </Form.Group>
                          {/* {item.maxError && (
                          <span style={{ color: "red", fontSize: "14px" }}>
                            Min amount should be greater than max amount
                          </span>
                        )} */}
                        </Col>

                        {/* <Col xl={2} lg={2} sm={6}>
                      <Form.Group className="d-flex align-items-center mb-2">
                        <Form.Label className="pe-2 mb-0">
                          Max Profit
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="maxProfit"
                          placeholder="Max Profit"
                          value={item.maxProfit}
                          onChange={(e) => handelChange(e, item.type)}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={2} lg={2} sm={6}>
                      <Form.Group className="d-flex align-items-center mb-2">
                        <Form.Label className="pe-2 mb-0">
                          Odds Limit
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="oddsLimit"
                          placeholder="Odds Limit"
                          value={item.oddsLimit}
                          onChange={(e) => handelChange(e, item.type)}
                        />
                      </Form.Group>
                    </Col> */}

                        <Col xl={3} lg={3} sm={6}>
                          <Form.Group className="d-flex align-items-start mb-2 flex-column">
                            {index == 0 && (
                              <Form.Label
                                style={{ fontSize: "16px" }}
                                className="pe-2 mb-2 w-lg-auto"
                              >
                                Bet Delay
                              </Form.Label>
                            )}
                            <Form.Control
                              type="number"
                              name="betDelay"
                              placeholder="Bet Delay"
                              // value={item.betDelay}
                              // onChange={(e) => handelChange(e, item.type)}
                              {...register(`${item?.type}BetDelay`, {
                                required: {
                                  values: false,
                                },
                                validate: (value) => {
                                  if (value == 0 && !isEmpty(value)) {
                                    return "value should be greater than zero";
                                  }
                                },
                              })}
                            />
                          </Form.Group>
                        </Col>

                        <Col xl={3} lg={3} sm={6}>
                          <Form.Group className="d-flex align-items-start mb-2 flex-column">
                            {index == 0 && (
                              <Form.Label
                                style={{ fontSize: "16px" }}
                                className="pe-2 mb-2 w-lg-auto"
                              >
                                Exposure
                              </Form.Label>
                            )}
                            <Form.Control
                              type="number"
                              name="exposure"
                              placeholder="Exposure"
                              // value={item.exposure}
                              // onChange={(e) => handelChange(e, item.type)}
                              {...register(`${item?.type}Exposure`, {
                                required: {
                                  values: false,
                                },
                                validate: (value) => {
                                  if (value == 0 && !isEmpty(value)) {
                                    return "value should be greater than zero";
                                  }
                                },
                              })}
                            />
                          </Form.Group>
                        </Col>
                        {/* <Col lg={2} sm={6}>
                      <Form.Check
                        label="ON (IS SHOWING)"
                        className="mb-2"
                        name="onShow"
                        checked={item.onShow == 1 ? true : false}
                        onChange={(e) => handelChange(e, item.type)}
                      />
                    </Col> */}
                      </Row>
                    </div>
                  );
                })}{" "}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  type="submit"
                  style={{
                    color: "black",
                    padding: "6px",
                    marginRight: "10px",
                  }}
                  className="green-btn"
                >
                  Set Limit
                </Button>{" "}
                <Button
                  type="button"
                  onClick={() => onClose()}
                  className="theme_light_btn btn btn-primary"
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </Container>
        </section>
      </Modal.Body>
    </Modal>
  );
};

export default SetLimit;
